import { IPAGE } from '@/types/base.d';
import { ISetting } from '@/types/set.d';
import fetch from './index';

// 添加系统配置
const addconfig = (data: ISetting) => fetch.axios_admin.post('config', data);

// 编辑系统配置
const editconfig = (data: ISetting) => fetch.axios_admin.put('config', data);

// 获取分页系统配置
const getconfig = (params: IPAGE) => fetch.axios_admin.get('config', { params });

// 删除角色
const removeconfig = (params: { id: string }) => fetch.axios_admin.remove('config', { params });

// 查询所有基础配置
const getConPage = (params: IPAGE, type: string) => fetch.axios_admin.get(`dict/page/${type}`, { params });

// 添加基础配置
const addCon = (params: FormData, type: string) => fetch.axios_admin.post(`dict/${type}`, params, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 修改基础配置
const editCon = (params: FormData, type: string) => fetch.axios_admin.put(`dict/${type}`, params, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 获取客户状态
const getCsrStatus = (params: IPAGE) => fetch.axios_admin.get('dict/customerStatus', params);

// 获取配置分类以及分类值
const getTypeList = () => fetch.axios_admin.get('dict/type');

// 课时定义接口-----
// 获取课时列表
const getCourseHours = (title: String) => fetch.axios_admin.get(`/lesson/hour/config?title=${title}`);

// 查询课程分类
const getCourseType = () => fetch.axios_admin.get('/lesson/hour/category');

// 保存课程配置
const addCourseConfig = (data: Object) => fetch.axios_admin.post('/lesson/hour/config', data);

// 编辑课程配置
const updateCourseConfig = (data: Object) => fetch.axios_admin.post('/lesson/hour/config', data);

// 删除课程配置
const removeCourseConfig = (id: String) => fetch.axios_admin.remove(`/lesson/hour/config?id=${id}`);

// 软件配置接口 start

// 查询
const getAppData = () => fetch.axios_admin.get('/download');

// 新增软件
const addApp = (params: object) => fetch.axios_admin.post('/download', params);

// 上传缩略图
const uploadAppImg = (params:any) => fetch.axios_admin.put('download/upload', params);

// 编辑软件信息
const editAppData = (params: any) => fetch.axios_admin.patch('download?pid', params);

// 删除软件信息
const removeAppConfig = (id: String) => fetch.axios_admin.remove(`download?pid=${id}`);

// 活动宣传海报接口——查询
const getActivityBanner = (datas: IPAGE) => fetch.axios_admin.get('/activity/findAllByPage', { datas });

// 活动宣传海报接口-新增
const addActivityBanner = (data: any) => fetch.axios_admin.post('/activity/create', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
// 活动宣传海报接口-修改
const editActivityBanner = (data: any) => fetch.axios_admin.post('/activity/update', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 活动宣传海报接口——查询单个
export const getActivityBannerById = (id: any) => fetch.axios_admin.post(`/activity/findById/${id}`);

// 软件配置接口 end

export default {
  addconfig,
  editconfig,
  getconfig,
  removeconfig,
  getConPage,
  addCon,
  editCon,
  getCsrStatus,
  getTypeList,
  getCourseHours,
  getCourseType,
  addCourseConfig,
  updateCourseConfig,
  removeCourseConfig,
  getAppData,
  addApp,
  uploadAppImg,
  editAppData,
  removeAppConfig,
  getActivityBanner,
  addActivityBanner,
  editActivityBanner,
  getActivityBannerById,
};
